module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _c('a', {
    attrs: {
      "id": "fig2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/map.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "fig2"
    }
  }, [_c('p', {
    staticClass: "figcaption"
  }, [_vm._v("The Battle-Fields of South Carolina, 1775–1780."), _c('br'), _vm._v("Edward McCrady, "), _c('i', [_vm._v("The History of South Carolina in the Revolution, 1780–1783")]), _vm._v(" (New York: Macmillan, 1902), ii.")])])]), _c('a', {
    attrs: {
      "id": "fig2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8abe74d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11_Fm03.vue
// module id = 87
// module chunks = 0